import { api } from '../api';

const unwrap = (r) => r.data?.data ?? r.data;

export default {
  /* ── plans & subscription ── */
  plans:      ()         => api.get('/v1/platform/plans').then(unwrap),
  createPlan: (body)     => api.post('/v1/platform/plans', body).then(unwrap),
  updatePlan: (id, body) => api.patch(`/v1/platform/plans/${id}`, body).then(unwrap),

  subscription: ()         => api.get('/v1/platform/subscription').then(unwrap),
  changePlan:   (planCode) => api.post('/v1/platform/subscription/change-plan', { planCode }).then(unwrap),
  cancelSubscription: ()   => api.post('/v1/platform/subscription/cancel').then(unwrap),

  /* ── onboarding ── */
  onboarding:         ()            => api.get('/v1/platform/onboarding').then(unwrap),
  updateOnboarding:   (body)        => api.patch('/v1/platform/onboarding', body).then(unwrap),
  updateStep:         (key, status) => api.patch(`/v1/platform/onboarding/steps/${key}`, { status }).then(unwrap),
  completeOnboarding: ()            => api.post('/v1/platform/onboarding/complete').then(unwrap),

  /* ── dealer health ── */
  health:          ()       => api.get('/v1/platform/health').then(unwrap),
  healthHistory:   (params) => api.get('/v1/platform/health/history', { params }).then(unwrap),
  recomputeHealth: ()       => api.post('/v1/platform/health/recompute').then(unwrap),
};
